/* eslint-disable camelcase */
import axios from 'axios';
import { PRODUCT_BOOST_ENDPOINT, PRODUCT_BOOST_RANGE_ENDPOINT } from '@dynameat/constants';

export const PERIOD_NOT_CONFIRMED = 'period_not_confirmed';
export const PRODUCT_BOOST_CONFLICT = 'product_boost_conflict';

export const productBoostListRequest = (product__point_of_sale__guid) => axios.get(
  PRODUCT_BOOST_ENDPOINT(),
  { params: { product__point_of_sale__guid, page_size: 0 } }
);

export const productBoostRangeRequest = (pointOfSaleGuid) => axios.get(
  PRODUCT_BOOST_RANGE_ENDPOINT(pointOfSaleGuid)
);

export const createProductBoostRequest = (productBoostData) => axios.post(PRODUCT_BOOST_ENDPOINT(), productBoostData);
export const removeProductBoostRequest = (productBoostGuid) => axios.delete(PRODUCT_BOOST_ENDPOINT(productBoostGuid));
